<template>
  <vxe-grid
    v-bind="gridOptions"
    :data="tableData"
    :columns="tableColumns"
    :span-method="mergeRowMethod"
  >
    <template v-slot:isSpecify="{row}">
      <el-tag size="mini" :type="row.isSpecify === 'Y' ? 'light' : 'info'">
        {{
          row.isSpecify === 'Y'
            ? $l('INDEX.YES') || '是'
            : $l('INDEX.NO') || '否'
        }}
      </el-tag>
    </template>
    <template v-slot:isCustomerProvide="{ row }">
      <el-tag size="mini" :type="row.isCustomerProvide === 'Y' ? 'light' : 'info'">
        {{
          row.isCustomerProvide === 'Y'
            ? $l('INDEX.order_form_label_isCustomerProvide_Y') || '是'
            : $l('INDEX.order_form_label_isCustomerProvide_N') || '否'
        }}
      </el-tag>
    </template>
  </vxe-grid>
</template>
<script>
import {request} from '@/api/service'
import tableColumns from './table-columns'
export default {
  props: {
    orderCode: String,
  },
  data() {
    return {
      gridOptions: {
        border: 'full',
        size: 'mini',
        toolbarConfig: {
          zoom: true,
        },
      },
      tableColumns: tableColumns(this),
      tableData: [],
    }
  },
  computed: {
    mergeCellByKey() {
      const mergeByKey = this.tableColumns.find((c) => c.mergeByKey)
      return mergeByKey ? mergeByKey.field : ''
    },
    mergeCell() {
      return this.tableColumns.filter((c) => c.merge).map((c) => c.field)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderCode) return
      request({
        url: '/factory/order/demand/fabric/listBySpec',
        method: 'post',
        data: {
          orderCode: this.orderCode,
        },
      }).then((res) => {
        this.tableData = res.body.data
      })
    },
    // 通用行合并函数（将相同多列数据合并为一行）
    mergeRowMethod({row, _rowIndex, column, visibleData}) {
      if (!this.mergeCellByKey) {
        return {rowspan: 1, colspan: 1}
      }
      const fields = this.mergeCell
      const cellValue = row[this.mergeCellByKey]

      if (fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[this.mergeCellByKey] === cellValue) {
          return {rowspan: 0, colspan: 0}
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[this.mergeCellByKey] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return {rowspan: countRowspan, colspan: 1}
          }
        }
      }
    },
  },
}
</script>
